import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./style.css";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";

gsap.registerPlugin(ScrollTrigger);

const lenis = new Lenis({
  duration: 2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
});

function raf(time) {
  lenis.raf(time);
  ScrollTrigger.update();
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);




THREE.ColorManagement.enabled = false;
let model;

/**
 * Base
 */
// Debug
// const gui = new dat.GUI()

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();
scene.background = new THREE.Color("#DCDBD0");

const textureLoader = new THREE.TextureLoader();
// const backgroundTexture = textureLoader.load('/images/bgSky.jpg');
// scene.background = backgroundTexture;

const loadingManager = new THREE.LoadingManager();

const progressBar = document.getElementById('progressBar');
const progressText = document.getElementById('progressText');
const enterButton = document.getElementById('enter');


loadingManager.onProgress = (url, loaded, total)=>{
   
    // progressBar.value = (loaded/total)*100;
    const progress = Math.round((loaded / total) * 100);
    progressText.textContent = `${progress}`; 
}

const progressBarContainer = document.querySelector('.progressBarContainer');

loadingManager.onLoad = ()=>{
   
  progressText.style.display = 'none'; 
  // enterButton.style.display = 'block'; 
    gsap.to(progressBarContainer,
    { 
      y:"-100%",
      duration:0.5})
 
}


const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath("/draco/");

const gltfLoader = new GLTFLoader(loadingManager);

gltfLoader.setDRACOLoader(dracoLoader);

let mixer = null;

gltfLoader.load("/model/peony_point_cloud/scene.gltf", (gltf) => {
  model = gltf.scene;
  model.scale.set(1.0, 1.0, 1.0); // Adjust the scale factor as needed
  model.position.set(-0.6, -3.7, 4);
  model.rotation.set(-1, 0, 0)

  scene.add(model);


  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.defaults({
    immediateRender: false,
    ease: "power1.inOut",
  });

  let modelMove = gsap.timeline({
    scrollTrigger: {
      trigger: ".horizontalScrollContainer",
      start: "top top",
      endTrigger: ".fifthPageImageHolder",
      end: "50% bottom",
      // markers: true,
      scrub: 1,
    },
  });

  modelMove
  .to(model.rotation, { x:-0.89, y:-0.6}, "runGrid1")
  .to(model.rotation, {  y:0}, "runGrid2")
  .to(model.position, { z: 5}, "runGrid2")
    // .to(model.position, { z:6 }, "runGrid")






});

const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
scene.add(ambientLight);

/* Sizes*/
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

// Base camera

const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.set(0, 2, 5);

scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;
controls.enableZoom = false;

/* Renderer */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.outputColorSpace = THREE.LinearSRGBColorSpace;
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));


/*Animate*/
// const clock = new THREE.Clock()

const clock = new THREE.Clock();
let previousTime = 0;

const tick = () => {
  const elapsedTime = clock.getElapsedTime();
  const deltaTime = elapsedTime - previousTime;
  previousTime = elapsedTime;

  controls.update();
  renderer.render(scene, camera);
  window.requestAnimationFrame(tick);
};





tick();




